import BootstrappingIntro from "../../../../contents/docs/feature-flags/snippets/bootstrapping-intro.mdx";
import * as React from 'react';
export default {
  BootstrappingIntro,
  React
};